export const GROUPE = 'Groupe';
export const ENSEIGNE = 'Enseigne';
export const POINT_VENTE = 'PointVente';
export const SOUS_TYPE = 'Aucun';
export const SOUS_TYPE_CONCURRENT = 'Concurrent';

export const TYPE_CLIENT = 'Client';
